import { Pipe, PipeTransform } from '@angular/core';
import { AiFeedbackProblemType } from '../enum/ai-feedback-problem-type.enum';

@Pipe({
  name: 'AiFeedbackProblemType',
  standalone: true,
})
export class AiFeedbackProblemTypePipe implements PipeTransform {
  transform(value: AiFeedbackProblemType | null): string {
    switch (value) {
      case AiFeedbackProblemType.Other:
        return 'aiFeedback.problemType.other';
      case AiFeedbackProblemType.IncorrectAnswer:
        return 'aiFeedback.problemType.incorrectAnswer';
      case AiFeedbackProblemType.IncompleteAnswer:
        return 'aiFeedback.problemType.incompleteAnswer';
      case AiFeedbackProblemType.Irrelevant:
        return 'aiFeedback.problemType.irrelevant';
      case AiFeedbackProblemType.Offensive:
        return 'aiFeedback.problemType.offensive';
      case AiFeedbackProblemType.Slow:
        return 'aiFeedback.problemType.slow';
      case AiFeedbackProblemType.InformationSecurityConsent:
        return 'aiFeedback.problemType.informationSecurityConsent';
      default:
        return '';
    }
  }
}
